(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_ke-size-guide"] && !Shopify.designMode) return;
  try {
    class KeSizeGuide extends HTMLElement {
    connectedCallback() {
      this.productDetails = this.closest('.product-details');
      this.handleChange = this.handleChange.bind(this);
      this.productDetails?.addEventListener('change', this.handleChange);
    }

    disconnectedCallback() {
      this.productDetails?.removeEventListener('change', this.handleChange);
    }

    handleChange(event) {
      const target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;

      const sizeInput = this.productDetails?.querySelector('input[data-option-name="Size"]:checked');
      const rawValue = sizeInput instanceof HTMLInputElement
        ? sizeInput.value
        : target instanceof HTMLSelectElement
          ? target.options[target.selectedIndex]?.value
          : target.value;
      const size = rawValue
        ?.replace(/\s*\((vertical|horizontal)\)/gi, '')
        .replace(/\s+/g, ' ')
        .trim();
      if (!size) return;

      const sizeElement = this.querySelector('.ke-size-guide__selected-size');
      const hintElement = this.querySelector('.ke-size-guide__selected-hint');
      const separator = this.querySelector('.ke-size-guide__sep');
      const digital = size.toLowerCase() === 'digital download';

      if (digital) {
        this.dataset.digital = 'true';
        if (sizeElement) sizeElement.textContent = 'Digital Download';
        if (hintElement) hintElement.hidden = true;
        if (separator) separator.hidden = true;
        return;
      }

      if (!/8|10|11|14|16|18|20|24|30|36|40/.test(size)) return;

      let hint = this.getAttribute('data-hint-8x10');
      if (size.includes('30') && size.includes('40')) hint = this.getAttribute('data-hint-30x40');
      else if (size.includes('24') && size.includes('36')) hint = this.getAttribute('data-hint-24x36');
      else if (size.includes('20') && size.includes('30')) hint = this.getAttribute('data-hint-20x30');
      else if (size.includes('18')) hint = this.getAttribute('data-hint-18x24');
      else if (size.includes('16')) hint = this.getAttribute('data-hint-16x20');
      else if (size.includes('11')) hint = this.getAttribute('data-hint-11x14');

      delete this.dataset.digital;
      if (sizeElement) sizeElement.textContent = size;
      if (hintElement) {
        hintElement.hidden = false;
        if (hint) hintElement.textContent = hint;
      }
      if (separator) separator.hidden = false;
    }
  }

  if (!customElements.get('ke-size-guide')) {
    customElements.define('ke-size-guide', KeSizeGuide);
  }
  } catch(e) { console.error(e); }
})();

})();
